import { ReactComponent as ReactIconLogo } from "../../../../assets/images/monitor_logo.svg";
import { ReactComponent as ReactIconBafar } from "../../../../assets/images/logo-bafar.svg";
import { ReactComponent as ReactIconNorgren } from "../../../../assets/images/Norgren-Logo.svg";
import { ReactComponent as ReactIconWalor } from "../../../../assets/images/logos/logo-walor.svg";
import { ReactComponent as ReactIconTwin } from "../../../../assets/images/logos/Icon_Twin.svg";
import Watlow from "../../../../assets/images/logos/watlow.png";
import Sisamex from "../../../../assets/images/logos/sisamex.png";

const styles = { display: "block", maxWidth: "100%", objectFit: "contain" };

export default function (id) {
  if (id == 164) {
    return <ReactIconBafar width="105" />;
  } else if (id == 120) {
    return <ReactIconNorgren width="100" />;
  } else if (id == 61 || id == 48) {
    return <ReactIconWalor width="100" />;
  } else if (id == 201) {
    return <img src={Watlow} style={styles} />;
  } else if (id == 114) {
    return <img src={Sisamex} style={styles} />;
  } else if (id == 206) {
    return <ReactIconTwin width="78" height="48" />;
  } else {
    return <ReactIconLogo />;
  }
}
